module.exports = __webpack_public_path__ + "img/homeTitleB.e3c516b7.png";